// Components
import { ServiceAgreement } from "../components";

const ServiceAgreementPage = () => {
  return (
    <>
      <ServiceAgreement />
    </>
  );
};

export default ServiceAgreementPage;
